import React, { useState, useRef } from 'react';
import { Box, Popper, Fade } from '@mui/material';
import { inclusiveGray } from 'shared/utils/inclusiveColors';

export function HoverWrapper({
  onHoverComponent,
  children,
  offset,
}: {
  onHoverComponent: React.ReactNode;
  children: React.ReactNode;
  offset?: [number, number];
}): React.ReactElement {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [open, setOpen] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();
  const handleMouseEnter = (
    event: React.MouseEvent<HTMLElement>
  ): void => {
    clearTimeout(timeoutRef.current);
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleMouseLeave = (): void => {
    timeoutRef.current = setTimeout(() => {
      setOpen(false);
    }, 100);
  };

  const modifiers = offset
    ? [
        {
          name: 'offset',
          options: {
            offset,
          },
        },
      ]
    : [];

  return (
    <Box
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      sx={{ display: 'inline-block', width: 'fit-content', maxWidth: '100%' }}
    >
      {children}
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement='bottom-start'
        transition
        modifiers={modifiers}
        sx={{
          zIndex: 1000,
          backgroundColor: inclusiveGray[50],
        }}
      >
        {({ TransitionProps }) => (
          <Fade
            {...TransitionProps}
            timeout={{ enter: 100, exit: 100 }}
            easing={{ enter: 'ease-out', exit: 'ease-in' }}
          >
            <Box
              onMouseEnter={() => clearTimeout(timeoutRef.current)}
              onMouseLeave={handleMouseLeave}
              sx={{
                transition: 'opacity 0.2s ease-out',
              }}
            >
              {onHoverComponent}
            </Box>
          </Fade>
        )}
      </Popper>
    </Box>
  );
}
